import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  FormGroup,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetGroups } from '../../api/Group';
import { APIgetUsers } from '../../api/User';

import AccessModalSelect from '../Access/ModalSelect';
import AccessModalList from '../Access/ModalList';

import LoadingSmall from '../LoadingSmall';

class UploadFileAccessGroupsUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
      groups: [],
      groupsLoading: true,
      users: [],
      usersLoading: true,
    };
  }

  componentDidMount() {
    this.loadUsers();
    this.loadGroups();
  }

  setDefaultCollabolators() {
    const {
      handleSwitchGroup,
      skipDefaultCollaborators,
    } = this.props;
    const { groups } = this.state;

    if (skipDefaultCollaborators) {
      return;
    }

    groups.forEach((group) => {
      if (group.default_in_upload) {
        handleSwitchGroup(group.uuid);
      }
    });
  }

  loadUsers() {
    this.setState({ usersLoading: true });

    APIgetUsers().then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ users: data });
      }
      this.setState({ usersLoading: false });
    });
  }

  loadGroups() {
    this.setState({ groupsLoading: true });

    APIgetGroups({ all: true }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ groups: data }, () => {
          this.setDefaultCollabolators();
        });
      }
      this.setState({ groupsLoading: false });
    });
  }

  render() {
    const {
      collapse,
      groupsLoading,
      usersLoading,
    } = this.state;
    const {
      intl,
      selectedGroups,
      selectedUsers,
      handleSwitchGroup,
      handleSwitchUser,
    } = this.props;

    return (
      <FormGroup className="upload-access">
        <hr />
        <a
          className="upload-access-switch"
          href="#access-open"
          onClick={(e) => {
            e.preventDefault();
            this.setState({ collapse: !collapse });
          }}
        >
          <h5>
            {intl.formatMessage({ defaultMessage: 'Access for users and Teams' })}
            {collapse ? (
              <i className="far fa-chevron-down" />
            ) : (
              <i className="far fa-chevron-right" />
            )}
          </h5>
        </a>
        <Collapse isOpen={collapse}>
          {groupsLoading ? (
            <LoadingSmall />
          ) : (
            <>
              <Label>
                {intl.formatMessage({ defaultMessage: 'Add users' })}
              </Label>
              <AccessModalSelect
                {...this.state}
                loading={usersLoading}
                listType="users"
                selectedUsers={selectedUsers.reduce((a, v) => ({ ...a, [v]: 1 }), {})}
                handleAddItem={handleSwitchUser}
              />
              <AccessModalList
                {...this.state}
                listType="users"
                selectedUsers={selectedUsers.reduce((a, v) => ({ ...a, [v]: 1 }), {})}
                collectionGroupAllowedUuids={[]}
                mode="files"
                filesCount={0}
                collectionsCount={0}
                hasItemAccessToCollectionGroup={() => (true)}
                handleAddItem={handleSwitchUser}
                handleRemoveItem={handleSwitchUser}
              />
              <Label>
                {intl.formatMessage({ defaultMessage: 'Add Teams' })}
              </Label>
              <AccessModalSelect
                {...this.state}
                loading={groupsLoading}
                listType="groups"
                selectedGroups={selectedGroups.reduce((a, v) => ({ ...a, [v]: 1 }), {})}
                handleAddItem={handleSwitchGroup}
              />
              <AccessModalList
                {...this.state}
                listType="groups"
                selectedGroups={selectedGroups.reduce((a, v) => ({ ...a, [v]: 1 }), {})}
                collectionGroupAllowedUuids={[]}
                mode="files"
                filesCount={0}
                collectionsCount={0}
                hasItemAccessToCollectionGroup={() => (true)}
                handleAddItem={handleSwitchGroup}
                handleRemoveItem={handleSwitchGroup}
              />
            </>
          )}
        </Collapse>
      </FormGroup>
    );
  }
}

UploadFileAccessGroupsUsers.propTypes = {
  intl: PropTypes.object.isRequired,
  selectedGroups: PropTypes.array.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  skipDefaultCollaborators: PropTypes.bool,
  handleSwitchGroup: PropTypes.func.isRequired,
  handleSwitchUser: PropTypes.func.isRequired,
};

UploadFileAccessGroupsUsers.defaultProps = {
  skipDefaultCollaborators: false,
};

export default injectIntl(UploadFileAccessGroupsUsers);
